import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createLinkProjection } from '../projections/createLinkProjection'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionCardsProjection = (localeId: LocaleId) => {
  const LINK_PROJECTION = createLinkProjection(localeId)
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        titleAlignment,
        verticalAlignment,
        spacing,
        topBorder,
        cards[] {
          _key,
          ${coalesceLocaleField('title', localeId)},
          ${coalesceLocaleField('content', localeId)},
          icon${MEDIA_PROJECTION},
          media${MEDIA_PROJECTION},
          action${LINK_PROJECTION},
          actions[] {
            ${coalesceLocaleField('label', localeId)},
            link${LINK_PROJECTION},
          }
        }
      }
  `
}
